"use strict";
// Similar to https://nodejs.org/api/assert.html but available in both browser and NodeJS.
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = exports.AssertionError = void 0;
class AssertionError extends Error {
    constructor(options) {
        options = options || {};
        if (!options.actual || !options.expected || !options.operator) {
            options.message || (options.message = "AssertionError");
        }
        else {
            options.message || (options.message = `AssertionError: Expected "${options.actual}" to "${options.operator}" "${options.expected}".`);
        }
        super(options.message);
        this.actual = options.actual;
        this.expected = options.expected;
        this.operator = options.operator || "";
    }
}
exports.AssertionError = AssertionError;
/*
 * This is useful for type narrowing.
 *
 * For example: you might have a function that returns a string or undefined.
 * You might _know_, out-of-band, that your call is going to return a string.
 * Therefore, you might opt to use a Typescript type assertion to avoid type complaints.
 * This gives you an alternative way to do type assertions that can include a useful error message.
 *
 * In the following examples, imagine that `GetParametersCommand` can return `undefined` if a parameter doesn't exist.
 * You _know_ that your parameter exists because you just logged into AWS and checked.
 *
 * Instead of:

    const command = new GetParametersCommand({
      Names: parameterNames,
      WithDecryption: opts?.withDecryption,
    });
    const response = await client.send(command);
    // This function should only be called with known parameters. If you get an error,
    // login to AWS Parameter store and make sure your parameter exists.
    return response.Parameters!;

  *
  * Notice the `!` assertion on the last line and the necessary comment before it.
  *
  * In the above example, if someone passes in a parameter that doesn't exist, they'll
  * eventually see an error message like:
  *
  * "Cannot read properties of undefined (reading Parameters)..."
  *
  * But if you use the following, then you'll get a much clearer error message.
  *
  * "Expected to find parameter values at "${parameterNames}". Confirm the parameter in your code matches a parameter in AWS Parameter Store."
  *

    const client = new SSMClient({ region: region });
    const command = new GetParametersCommand({
      Names: parameterNames,
      WithDecryption: opts?.withDecryption,
    });
    const response = await client.send(command);
    assert(!!(response.Parameters?.length == parameterNames.length), {
      message: `Expected to find parameter values at "${parameterNames}". Confirm the parameter in your code matches a parameter in AWS Parameter Store.`,
    });
    return response.Parameters;
 *
 */
const assert = (condition, options) => {
    if (!condition)
        throw new AssertionError(options);
};
exports.assert = assert;
//# sourceMappingURL=AssertHelper.js.map